import _ from 'lodash'

export default subscriptionContactUnknownPRMCtrl

/** @ngInject */
function subscriptionContactUnknownPRMCtrl($scope, $uibModalInstance, DeviceChecker, Contact, gaEventsService, ErrorCatcher,
                                           MailAdresses, email, phone) {
    const RECONTACT_MSG = '\n\n[AUTOMATIQUE] Je souhaite être rappelé afin de terminer ma souscription par téléphone.'
    $scope.gaEventsService = gaEventsService
    $scope.mailAdresse = MailAdresses
    $scope.form = {
        api: {},
        isSending: false,
        isContactSent: false,
        canRecontact: false,
        minDate: new Date(),
        error: {
            hasError: false,
            message: '',
        },
        model: {
            type: 'task',
            subject: 'Numéro de point de livraison inconnu',
            dueDate: new Date().toISOString(),
            email,
            phone,
            postalAddress: undefined,
            previousOccupant: undefined,
            serial: undefined,
            body: undefined,
        },
    }

    $scope.close = (evnt) => $uibModalInstance.dismiss()

    $scope.isMobile = DeviceChecker.isMobile

    $scope.sendMessage = function (form) {
        form.api.$setSubmitted()
        if (form.api.$invalid) {
            return
        }

        form.isSending = true
        Contact.sendMessage({}, _.assign({}, form.model, { body: form.model.body + RECONTACT_MSG })).$promise
        .then(() => {
            form.isContactSent = true
        })
        .catch((error) => {
            form.error.hasError = true
            form.error.message = error.data.message
            return ErrorCatcher.catchError(error)
        })
        .finally(() => {
            form.isSending = false
        })
    }
}



// WEBPACK FOOTER //
// ./src/states/subscription/modal/subscriptionContactUnknownPRM.js